export default function singleSubmit(block) {
	const getAJAXRequests = (function() {
		const oldSend = XMLHttpRequest.prototype.send,
			currentRequests = [];

		XMLHttpRequest.prototype.send = function() {
			currentRequests.push(this); // add this request to the stack
			oldSend.apply(this, arguments); // run the original function

			// add an event listener to remove the object from the array
			// when the request is complete
			this.addEventListener('readystatechange', function() {
				let idx;

				if (this.readyState === XMLHttpRequest.DONE) {
					idx = currentRequests.indexOf(this);
					if (idx > -1) {
						currentRequests.splice(idx, 1);
					}
				}
			}, false);
		};

		return function() {
			return currentRequests;
		}
	}());

	let windowUnloading = false
	window.addEventListener("beforeunload", (e) => {
		windowUnloading = true;
	});

	block.addEventListener('submit', (event) => {
		const form = event.target;
		const buttons = form.querySelectorAll('[data-single-click]');
		buttons.forEach((button) => {
			button.setAttribute('disabled', 'disabled');
			const newText = button.getAttribute('data-single-click');
			const newClass = button.getAttribute('data-single-click-class');

			const oldText = button.innerHTML;
			const oldClass = button.getAttribute('class');

			if (newText.length > 0 && newText !== 1 && newText !== true) {
				button.innerHTML = newText;
			}
			if (newClass) {
				button.setAttribute('class', newClass);
			}

			setTimeout(() => {
				if (windowUnloading === false && getAJAXRequests().length === 0) {
					button.removeAttribute('disabled');
					if (newText.length > 0 && newText !== 1 && newText !== true) {
						button.innerHTML = oldText;
					}
					if (newClass) {
						button.setAttribute('class', oldClass);
					}
				}
			}, 200);
		});
	});
}